/**
 * System Admin LocalStorage Utilities
 *
 * Deliberately separate from utils/storage.ts (tenant auth) - uses a
 * distinct key so a system admin session and a tenant session can never be
 * confused with each other in the browser's storage.
 */

const ADMIN_STORAGE_KEYS = {
  AUTH_TOKEN: 'crm_admin_auth_token',
} as const;

/**
 * Save system admin authentication token
 */
export function saveAdminAuthToken(token: string): void {
  try {
    localStorage.setItem(ADMIN_STORAGE_KEYS.AUTH_TOKEN, token);
  } catch (error) {
    console.error('Failed to save admin auth token:', error);
  }
}

/**
 * Get system admin authentication token
 */
export function getAdminAuthToken(): string | null {
  try {
    return localStorage.getItem(ADMIN_STORAGE_KEYS.AUTH_TOKEN);
  } catch (error) {
    console.error('Failed to get admin auth token:', error);
    return null;
  }
}

/**
 * Clear system admin authentication token
 */
export function clearAdminAuthStorage(): void {
  try {
    localStorage.removeItem(ADMIN_STORAGE_KEYS.AUTH_TOKEN);
  } catch (error) {
    console.error('Failed to clear admin auth storage:', error);
  }
}
